import { render, staticRenderFns } from "./EventHistoryAgreementParams.vue?vue&type=template&id=2f188eba&scoped=true"
import script from "./EventHistoryAgreementParams.vue?vue&type=script&lang=js"
export * from "./EventHistoryAgreementParams.vue?vue&type=script&lang=js"
import style0 from "./EventHistoryAgreementParams.vue?vue&type=style&index=0&id=2f188eba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f188eba",
  null
  
)

export default component.exports